/**
 * Created by jv on 2019-09-10 (14:33).
 */
// import Shared from "Sources/shared";
import utils from "Sources/utils/utils";
import GameView from "Sources/components/game/views/game-view";
import htmlView from "Views/partials/game/introduction.html";
import FormValidator from "Sources/components/form-validator";

// import WasteDepotView from "Sources/components/popup/waste-depot";
// import ResourceSubstitutionView from "Sources/components/popup/resource-substitution";
// import ResourceLessView from "Sources/components/popup/resource-less";
// import InvestmentsView from "../components/investments-view";
// import RentalServiceView from "Sources/components/popup/rental-service";
// import EventDialog from "Sources/components/game/components/event-dialog";

// const log = require("Sources/utils/logger")();

require("Styles/components/views/introduction.scss");

class IntroductionView extends GameView
{
    constructor(options)
    {
        options.html = $(htmlView);
        super(options);

        this.currentStep = 1;
        this.path = "introduction";
        this.onIntroductionCompleted = options.onIntroductionCompleted;
        this.onTeamNameRegistered = options.onTeamNameRegistered;
    }

    render()
    {
        super.render();
        this._setUpEventListeners();
        this.showCurrentStep();

        // this.TEMP_SHOW_WASTE_DEPOT();
        // this.TEMP_SHOW_RESOURCE_SUBSTITUTION();
        // this.TEMP_SHOW_RESOURCE_LESS();
        // this.TEMP_RENTAL();
        // this.TEMP_EVENT();

        this.onRender();

        // this.$element.find(".next-intro-btn").prop("disabled", true);
    }

    onRender()
    {
        super.onRender();

        this.formValidator = new FormValidator({
            selector: this.$element.find(".join-session-form"),
            validateOnChange: true,
            rules: {
                "team-name": {
                    required: true,
                    maxLength: 20,

                    validator: (value) =>
                    {
                        let regex = new RegExp("^[a-zA-Z0-9\-_ ]+$"); // only allow alphanumeric, space, - and _ (keep in sync with GameSessionController.java)
                        return !utils.isNullOrEmpty(value) && value.trim() !== "" && regex.test(value);
                    },
                    // tooltip: LanguageManager.getValueForKey("serious_game.session.form.session_name.tooltip"),

                }
            },
            onValidateElement: ($element, isValid) =>
            {
                this.$element.find(".next-intro-btn").prop("disabled", !isValid);
            }
        });
    }

    setFormErrors(errorMessage)
    {
        this.clearFormErrors();
        let $formError = $("<div class='form-error'></div>").text(errorMessage);
        this.$element.find(".form-errors").append($formError);
    }

    clearFormErrors()
    {
        this.$element.find(".form-errors").empty();
    }

    // TEMP_EVENT()
    // {
    //     this.eventDialog = new EventDialog({
    //         // callbackContext: this,
    //         // onCancel: this.onEventDialogCancel,
    //     });
    //
    //     this.eventDialog.create();
    //
    //     let event = {
    //         type: "new-materials", // tax, conditions, new-materials
    //         jsonData: {
    //             // for tax
    //             // "factory-count": 1,
    //             // for new-materials
    //             "red": 1,
    //             "yellow": 1
    //         }
    //     };
    //
    //     this.eventDialog.event = event;
    //     this.eventDialog.show();
    // }

    // TEMP_RENTAL()
    // {
    //     let container = $("<div>");
    //
    //     let resourceType = "bike";
    //
    //     let rentalView = new RentalServiceView({
    //         container: container,
    //         resourceType: resourceType,
    //         canAddResources: false
    //     });
    //
    //     rentalView.render();
    //
    //     Shared.Dialog.showMessageDialog({
    //         title: "",
    //         message: container,
    //         disposable: false,
    //         confirmText: "rentalservice.rentproducts",
    //         dialogId: "rental-service-modal-dialog",
    //         extraModalContentClass: "rental-service-background-container",
    //         onConfirm: () =>
    //         {
    //
    //         }
    //     });
    // }
    //
    // TEMP_SHOW_WASTE_DEPOT()
    // {
    //     let container = $("<div>");
    //
    //     let wasteDepot = new WasteDepotView({ container: container });
    //
    //     wasteDepot.render();
    //
    //     Shared.Dialog.showMessageDialog({
    //         title: "",
    //         message: container,
    //         disposable: false,
    //         dialogId: "waste-depot-dialog",
    //         extraModalContentClass: "waste-depot-background-container",
    //         onConfirm: () =>
    //         {
    //             let resources = wasteDepot.getChosenResources();
    //
    //             // todo: tv: do something with the resources
    //             log.info(resources);
    //         }
    //     });
    // }
    //
    // TEMP_SHOW_RESOURCE_SUBSTITUTION()
    // {
    //     let container = $("<div>");
    //
    //     let resourceView = new ResourceSubstitutionView({ container: container });
    //
    //     resourceView.render();
    //
    //     Shared.Dialog.showMessageDialog({
    //         title: "",
    //         message: container,
    //         disposable: false,
    //         extraModalContentClass: "resource-substitution-background-container",
    //         onConfirm: () =>
    //         {
    //             let resources = resourceView.getReplacedResource();
    //
    //             // todo: tv: do something with the resources
    //             log.info(resources);
    //         }
    //     });
    // }
    //
    // TEMP_SHOW_RESOURCE_LESS()
    // {
    //     let container = $("<div>");
    //
    //     let resourceView = new ResourceLessView({ container: container });
    //
    //     resourceView.render();
    //
    //     Shared.Dialog.showMessageDialog({
    //         title: "",
    //         message: container,
    //         disposable: false,
    //         extraModalContentClass: "resource-less-background-container",
    //         onConfirm: () =>
    //         {
    //             let resources = resourceView.getRemovedResource();
    //
    //             // todo: tv: do something with the resources
    //             log.info(resources);
    //         }
    //     });
    // }

    setLoadingState(flag)
    {
        let $skipBtn = this.$element.find(".skip-intro-btn");

        $skipBtn.removeClass("btn-loading").prop("disabled", flag);

        if (flag)
        {
            $skipBtn.addClass("btn-loading");
        }
    }

    showCurrentStep()
    {
        let nextBtn = this.$element.find(".next-intro-btn");
        let previousBtn = this.$element.find(".previous-intro-btn");
        let skipBtn = this.$element.find(".skip-intro-btn");

        skipBtn.hide();
        previousBtn.show();
        nextBtn.show();

        this.$element.find(".introduction-step").hide();
        this.$element.find("#introduction-step-" + this.currentStep).show();

        if (this.currentStep === 1)
        {
            previousBtn.hide();
        }
        else if (this.currentStep === 4)
        {
            nextBtn.hide();
            skipBtn.show();
        }
    }

    _setUpEventListeners()
    {
        let input = this.$element.find("#preemptive-session-name-input");

        this.$element.find(".skip-intro-btn").off("click").on("click", (e) =>
        {
            this.onTeamNameRegistered.call(this, input.val());
            this.onIntroductionCompleted.call(this, true);
        });

        this.$element.find(".next-intro-btn").off("click").on("click", (e) =>
        {
            this.currentStep++;
            this.showCurrentStep();
        });

        this.$element.find(".previous-intro-btn").off("click").on("click", (e) =>
        {
            this.currentStep--;
            this.showCurrentStep();
        });
    }
}

module.exports = IntroductionView;



// WEBPACK FOOTER //
// ./app/js/components/game/views/introduction.js